enum NodeName {
    // controller
    FullscreenGestureController = 'FullscreenGestureController',

    // game object
    IdleHintGizmo = 'IdleHintGizmo',
    Logo = 'Logo',
    JackpotWin = 'JackpotWin',

    // popup
    HistoryPage = 'HistoryPage',
    GameRulePopup = 'GameRulePopup',
    QuitGameDialog = 'QuitGameDialog',
    SwipeHintPopup = 'SwipeHintPopup',
    IdleHintPopup = 'IdleHintPopup',
    GameMenuPage = 'GameMenuPage',
    LobbyMenuPage = 'LobbyMenuPage',
    TutorialPlayer = 'TutorialPlayer',
    NotificationPopup = 'NotificationPopup',
    ResumeGameDialog = 'ResumeGameDialog',
    YouTubePlayerPopup = 'YouTubePlayerPopup',
    EnterMachineDialog = 'EnterMachineDialog',
    JackpotPage = 'JackpotPage',
    JackpotRecordPage = 'JackpotRecordPage',
    GameRuleImageViewer = 'GameRuleImageViewer',
    FreePlayDialog = 'FreePlayDialog',
    JPHasBeenWonPopup = 'JPHasBeenWonPopup',

    // transition
    LoadingMachineTransition = 'LoadingMachineTransition',
}

export enum SceneName {
    OuterLobby = 'OuterLobby',
    Lobby = 'Lobby',
    SinglePlay = 'SinglePlay',
}

export default NodeName;
